export const CVReview_2055 = [
	'overview',
	'subject',
	'neighborhood',
	'improvements',
	'comps',
	'salesapproach',
	'costapproach',
	'incomeapproach',
	'reconciliation',
	'pdfreview',
	'photoreview',
	'helpcenter'
];
